module.exports = __webpack_public_path__ + "img/news-1.0ae9709.webp";